import styles from "../../communication-chat.module.css";
import moment from "moment";

const getInitials = (firstName, lastName) => {
  const first = firstName ? firstName.charAt(0).toUpperCase() : "";
  const last = lastName ? lastName.charAt(0).toUpperCase() : "";
  return first + last || "?";
};

const getAvatarUrl = (user_image) => {
  if (!user_image || user_image === "") return null;
  return `${process.env.REACT_APP_PROSPECT_TENANT_IMAGE_BASE_URL}${user_image}`;
};

const AssignedTenantConversations = (props) => {
  const items = props.items || [];

  console.log('props');
  console.log(props);
  console.log(items);

  if (items.length === 0) return null;

  return (
    <div>
      <div className={`${styles.TeamGroupTopHead}`}>My Assigned Requests</div>
      {items.map((item) => {
        const avatarUrl = getAvatarUrl(item.user_image);
        return (
          <div
            key={item.request_id}
            className={`${styles.CommuListSec} ${styles.Request}`}
            onClick={(e) => {
              e.stopPropagation();
              props.onSelect(item);
            }}
          >
            <div className={`${styles.RequestListMainSec}`}>
              <div className={`${styles.EmployeeAvatarSec}`}>
                {avatarUrl ? (
                  <img
                    src={avatarUrl}
                    alt=""
                    className={`${styles.EmpAvatarImg}`}
                  />
                ) : (
                  <p className={`${styles.EmpAvatarInitials}`}>
                    {getInitials(item.first_name, item.last_name)}
                  </p>
                )}
              </div>
              <div className={`${styles.CommuListDeSec}`}>
                <div className={`${styles.HeadSec}`}>
                  <p className={`${styles.ProsTenantList}`}>
                    <span>{item.first_name} {item.last_name}</span>
                    <span className={`${styles.Bullet}`}>{item.apt_no}</span>
                  </p>
                  {item.message_time && (
                    <p className={`${styles.UnreadMessageTime}`}>
                      {moment(item.message_time).fromNow()}
                    </p>
                  )}
                </div>
                <div className={`${styles.displayFlexCustom}`}>
                  <div className={`${styles.MassageSec}`}>
                    <p className={`${styles.ProsTenantListDe}`}>
                      <span>{item.title}</span>
                      <span>{item.request_no}</span>
                    </p>
                    {item.message && (
                      <p
                        className={`${styles.UnreadMessage} ${item.unread_no > 0 ? styles.Unread : ""
                          }`}
                      >
                        {item.message}
                      </p>
                    )}
                  </div>
                  <div>
                    {item.unread_no > 0 && (
                      <span className={`${styles.PropertyGroupNotiCount}`}>
                        {item.unread_no}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default AssignedTenantConversations;
